/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import { useDynamicPosition } from "../../utils";
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'popover';

/**
 * This is the component description.
 */
const Popover = ({
  id,
  className: userClassName,
  style,
  color,
  children,
  isOpen,
  parentRef,
  preferredPrimaryOrder,
  preferredSecondaryOrder,
  offsetXPx,
  offsetYPx
  // ...otherProps
}) => {
  const popoverRef = useRef(null);
  const {
    primaryPosition,
    secondaryPosition
  } = useDynamicPosition({
    preferredPrimaryOrder,
    preferredSecondaryOrder,
    elementRef: popoverRef,
    parentRef,
    offsetXPx,
    offsetYPx
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, isOpen && 'open', `x-${color}`, primaryPosition, secondaryPosition].filter(e => e).join(' '),
    style: style,
    ref: popoverRef
    // {...otherProps}
  }, children);
};
Popover.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * The base color of the popover
   */
  color: PropTypes.string,
  /**
   * Whether the popover should be visible or not
   */
  isOpen: PropTypes.bool,
  /**
   * The preferred primary position order of the popover
   */
  preferredPrimaryOrder: PropTypes.arrayOf(PropTypes.oneOf(['bottom', 'top', 'right', 'left'])),
  /**
   * The preferred secondary position order of the popover
   */
  preferredSecondaryOrder: PropTypes.arrayOf(PropTypes.oneOf(['left', 'right', 'bottom', 'top'])),
  /**
   * The horizonal offset in pixels from the anchor point to the popover
   */
  offsetXPx: PropTypes.number,
  /**
   * The vertical offset in pixels from the anchor point to the popover
   */
  offsetYPx: PropTypes.number,
  /**
   * The reference to the parent element
   */
  parentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.node
  })])
};
Popover.defaultProps = {
  color: 'background-near',
  isOpen: false,
  preferredPrimaryOrder: ['bottom', 'top', 'right', 'left'],
  preferredSecondaryOrder: ['left', 'right', 'bottom', 'top'],
  offsetXPx: 16,
  offsetYPx: 0
};
export default Popover;